'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/*
 * @Author: Paco
 * @Date: 2018-11-28 16:38:52
 * @LastEditTIme: Paco
 * @Description:
 */

exports.default = function (_ref) {
  var dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      var promise = action.promise,
          data = action.data,
          success = action.success,
          error = action.error,
          type = action.type,
          model = action.model,
          rest = _objectWithoutProperties(action, ['promise', 'data', 'success', 'error', 'type', 'model']);

      if (promise) {
        return promise.then(function () {
          var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          if (model && typeof model === 'function') {
            json = model(json);
          }
          if (type) {
            //define data to dispatch
            var dispatchData = void 0;

            if (data) {
              if (typeof data === 'function') {
                dispatchData = data(json);
              } else {
                dispatchData = data;
              }
            } else {
              dispatchData = json;
            }

            //dispatch
            next(_extends({
              type: type,
              data: dispatchData
            }, rest));
          }

          if (typeof success === 'function') {
            success(json, dispatch);
          }

          //return data for promise chain
          return json;
        }).catch(function (err) {
          //fail for plugins after promise

          if (typeof error === 'function') {
            error(err, dispatch);
          } else {
            return Promise.reject(err);
          }
        });
      } else {
        return next(action);
      }
    };
  };
};